import _ from 'lodash';
import { createSelector } from 'reselect';


// ======================
// REDUCERS
// ====================== 

// Creates a new list for the store
export function createList(items, model, modelKey) {
  return {
    list: _.map(items, modelKey),
    model,
    modelKey,
  }
}

export const mergeList = (listA, listB, unique = true) => {
  return {
    list: _.union(listA?.list, listB?.list),
    model: listA?.model ?? listB.model,
    modelKey: listA?.modelKey ?? listB?.modelKey,
  }
}

// Reduces a new set of items into the list
export function listReducer(state, listType, items, itemKey, model, modelKey = '_id') {
  let newLists = items
    |> _.castArray
    |> _.groupBy(#, itemKey)
    |> _.mapValues(#, items => createList(items, model, modelKey))
  return {
    ..._.mergeWith(state[listType], newLists, mergeList)
  };
}

export function listWithout(state, listType, ids) {
  ids = _.castArray(ids);
  return _.mapValues(state[listType], list => Object.assign({ ...list, list: _.remove(list.list, ids)}) )
}

// Reduces a new set of items into the list of a specific key
export function listReducerByKey(state, listType, items, model, listKey, modelKey = '_id') {
  return {
    ...state[listType],
    [listKey]: createList(items, model, modelKey),
  };
}



// ======================
// SELECTORS
// ====================== 
// Creates a selector that whenever the models or the specific list changes, fetch the models
export const createListSelector = (listType, selectors = []) => createSelector(
  (state, listKey) => state.models[selectList(state, listType, listKey)?.model],
  (state, listKey) => selectList(state, listType, listKey),
  ...selectors,
  (models, list) => _.pick(models, list?.list)
)

export const selectList = (state, listType, listKey) => listKey ? state.lists[listType]?.[listKey] : state.lists[listType];
export const selectLists = (state, list) => state.lists[list];

// Selects the models that a list represents
export const selectListModels = (state, listType, key) => {
  let { list: ids, model: modelType, modelKey } = state.lists[listType]?.[key] ?? {};
  return _.pick(state.models?.[modelType], ids)
    |> _.values(#)
}

